import React from "react";

import { APPEARANCE_THEME, getAppearanceTheme } from "../../helpers/userPreferences";

const OPTIONS = [
  { value: APPEARANCE_THEME.LIGHT, label: "Light" },
  { value: APPEARANCE_THEME.DARK, label: "Dark" },
  { value: APPEARANCE_THEME.SYSTEM, label: "System" },
];

export function AppearanceSettingsSection({ preferences, onUpdatePreferences, saving = false }) {
  const theme = getAppearanceTheme(preferences);

  return (
    <div className="user-preferences__group">
      <h3 className="user-preferences__heading">Appearance</h3>
      <div>
        <span className="user-preferences__label">Theme</span>
        <p className="user-preferences__hint">
          "System" follows your device or browser's light/dark setting.
        </p>
        <div
          className="user-preferences__segmented"
          role="radiogroup"
          aria-label="Appearance theme"
        >
          {OPTIONS.map((option) => (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={theme === option.value}
              disabled={saving}
              className={`user-preferences__segmented-btn${
                theme === option.value ? " is-active" : ""
              }`}
              onClick={() =>
                onUpdatePreferences({ appearance: { theme: option.value } })
              }
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
